import { Component } from "@angular/core";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastModule } from "primeng/toast";
import { CompReviewServiceService } from "./comp-review-service.service";
import { TabsModule } from "primeng/tabs";
import { Router, RouterModule } from "@angular/router";

@Component({
  selector: 'app-comparative-review',
  standalone: true,
  imports: [
    TabsModule, ToastModule, ConfirmDialogModule, RouterModule],
  templateUrl: './comparative-review.component.html',
  styleUrl: './comparative-review.component.scss',
  providers: [CompReviewServiceService]
})
export class ComparativeReviewComponent {
  tabPanel: any = [];
  constructor(private readonly compReviewServiceService: CompReviewServiceService,
    private readonly router: Router
  ) {
    this.compReviewServiceService.getLastReportDate();
  }

  ngOnInit(): void {
    this.tabPanel = [
        { route: '/pages/CAT/Comparative-Review/Sample', label: 'Create & Review Sample Results'},
        { route: '/pages/CAT/Comparative-Review/Exception', label: 'Exception Report'}
   ];
    this.router.navigate(['/pages/CAT/Comparative-Review/Exception']);
  }
}